import styled from 'styled-components';
import { Tag as TagComponent } from 'antd';

export const Tag = styled(TagComponent)``;
